import { createContext, useContext } from 'react'
import { SizeTier, TIER_MULTIPLIERS } from '~/styles/subtitleStyle'

export type { SizeTier }

const STORAGE_KEY = 'fontSizeTier'

export function readFontSizeTier(): SizeTier {
  if (typeof window === 'undefined') return 'medium'
  const v = window.localStorage.getItem(STORAGE_KEY)
  if (v === null || !(v in TIER_MULTIPLIERS)) return 'medium'
  return v as SizeTier
}

export function writeFontSizeTier(tier: SizeTier) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, tier)
  }
}

type FontSizeTierContextType = {
  sizeTier: SizeTier
  updateSizeTier: (tier: SizeTier) => void
}

export const FontSizeTierContext = createContext<FontSizeTierContextType>({
  sizeTier: 'medium',
  updateSizeTier: () => {},
})

export const useFontSizeTier = () => {
  const context = useContext(FontSizeTierContext)

  return context
}
